"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
exports.css = withCompInfo_1.withCompInfo(['compLayout'], function (_a) {
    var compLayout = _a.compLayout;
    return {
        height: 'auto',
        'min-height': compLayout.height + "px",
    };
});
//# sourceMappingURL=LoginButton.js.map